import Coalition from "./Coalition";
import Quick from "./Quick";
import Badge from "./Badge";

function Body() {
    return (
        <div>
            <Coalition />
            <Quick />
            <Badge />
        </div>
    );
}

export default Body;